<stx-generic-wide-page>
  <stx-report-header>
    {{ 'reports.surgery_stats' | translate }}
  </stx-report-header>
  <stx-report-filters [reportConfig]="reportConfig" (applyFilters)="applyFilters($event)"></stx-report-filters>
  @if (reportService.filtersReady$ | async) {
  <stx-surgery-stats-report-table></stx-surgery-stats-report-table>
  }
</stx-generic-wide-page>
